import { setUserAboutData } from '@/store';
import { setUserPreferences } from '@/store';
import { api } from '@/api';
import { USER_ABOUT_TAG } from '@/api';
import { handleQueryLifecycle } from '../utils';

export const UserRoleType = {
  GLOBAL_ADMIN: 'GLOBAL_ADMIN',
  LAWYER: 'LAWYER',
  ADMIN: 'ADMIN',
} as const;

export const UserRoleLabels = {
  GLOBAL_ADMIN: 'Global Admin',
  LAWYER: 'Lawyer',
  ADMIN: 'Admin',
} as const;

export type UserRoleType = (typeof UserRoleType)[keyof typeof UserRoleType];

export interface UserAboutData {
  greeting: string;
  name: string;
  role: UserRoleType;
  userId: string;
  organisationId: string;
}

export interface UserPreferencesData {
  enterToSend: boolean;
}

export type UserAboutResponse = {
  userInfo: UserAboutData;
  preferences: UserPreferencesData;
};

type GetUserAboutProps = {
  abortController?: AbortController;
};

const getUserAboutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserAbout: builder.query<UserAboutResponse, GetUserAboutProps>({
      query: ({ abortController = new AbortController() }: GetUserAboutProps) => ({
        url: `user/about`,
        method: 'GET',
        signal: abortController.signal,
      }),
      providesTags: () => [{ type: USER_ABOUT_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, (data) => {
          dispatch(setUserAboutData(data.userInfo));
          dispatch(setUserPreferences(data.preferences));
        });
      },
    }),
  }),
});

export const { useLazyGetUserAboutQuery, useGetUserAboutQuery } = getUserAboutApi;
